export default __webpack_public_path__ + "static/media/arrow-bg.f4fbf9b9.svg";